require('./administrators');
require('./agents');
require('./buses');
require('./change-password');
require('./cities');
require('./currencies');
require('./discounts');
require('./lines');
require('./offices');
require('./prices');
require('./promotions');
require('./reports');
require('./sales');
require('./seats');
require('./stations');
require('./tickets');
require('./waybill');
require('./negotiated-seats');

import LoginRoute from './private.route';
import PrivateLocale from './private.locale';
angular.module('BTMS')
	.config(LoginRoute)
	.config(PrivateLocale);



/** WEBPACK FOOTER **
 ** ./client/private/index.js
 **/